import { GET, PUT } from 'utils/requests.utils'

const BASE_URL = '/common/publisher'

export const fetchItem = (data = {}) => GET(BASE_URL, data)

export const updateItem = (data) => PUT(BASE_URL, data)
